<template>
  <Layout
    header-class="header-left-align"
    :footer-style="4"
    buy-button-class="btn-default btn-small"
    :show-top-header="false"
    :show-copyright="false"
    :show-theme-switcher-button="false"
    :header-style="2"
    :other-bg="true"
  >
    <div class="slider-area slider-style-3" style="min-height: calc(100vh - 130px);">
      <div class="container" style="margin-top: 50px;">
        <div class="depost-area">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-bottom: 1px solid rgba(255, 255, 255, 0.17);
              padding: 0px 56px 33px 56px;
            "
          >
            <div style="max-width: 391px; margin-right: 100px">
              <div
                style="
                  font-size: 24px;
                  font-weight: 700;
                  color: #fff;
                  padding-bottom: 5px;
                "
              >
                Desposite ETH
              </div>
              <div style="font-size: 20px; color: #67696d">
                Provide liquidity for borrowers by depositing into the Lend Pool
              </div>
            </div>
            <div>
              <Counter
                :counter-style="8"
                text-align="text-start"
                :counter-data="counterFiveData"
                column="col-4"
              />
            </div>
          </div>
          <div style="display: flex; align-items: center; padding-top: 33px;padding-right: 56px;padding-left: 56px;">
            <div
              :class="
                active === 1 ? 'depost-btn depost-btn-active' : 'depost-btn'
              "
              @click="active = 1"
            >
              Desposite ETH
            </div>
            <div
              :class="
                active === 2 ? 'depost-btn depost-btn-active' : 'depost-btn'
              "
              @click="active = 2"
            >
              Withdraw ETH
            </div>
            <div
              :class="
                active === 3 ? 'depost-btn depost-btn-active' : 'depost-btn'
              "
              @click="active = 3"
            >
              ClaimReward
            </div>
          </div>
          <div style="background: #1C2333;padding: 42px 53px 56px 53px;">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 32px 104px 36px 84px;
                margin-bottom: 42px;
                border-radius: 35px;
                border: 1px solid rgba(255, 255, 255, 0.5);
              "
            >
              <div>
                <div
                  style="margin-bottom: 22px; color: #67696d; font-size: 20px"
                >
                  Amount
                </div>
                <div>
                  <el-input v-model="value" placeholder="" @input ="value = value.replace(/[^0-9.]/g,'')" class="amount-input"></el-input>
                </div>
              </div>
              <div>
                <div style="margin-bottom: 14px">Balance: 0.00eth</div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div
                    style="
                      width: 92.84px;
                      height: 32.407px;
                      border-radius: 53px;
                      background: #606060;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #fff;
                      font-size: 20px;
                      font-weight: 900;
                      margin-right: 20px;
                    "
                  >
                    MAX
                  </div>
                  <div style="display: flex; align-items: center">
                    <img :src="iconOne" style="width: 36px; height: 36px" />
                    <div
                      style="
                        font-size: 24px;
                        font-weight: 900;
                        color: white;
                        margin-left: 9px;
                      "
                    >
                      ETH
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 42px;
              "
            >
              <div class="action-btn" style="margin-right: 56px">Back</div>
              <div class="action-btn">
                {{
                  active === 1
                    ? 'Desposite'
                    : active === 2
                    ? 'Withdraw'
                    : 'Claim'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Icon from '@/components/icon/Icon'
import Counter from '@/components/elements/counterUp/Counter'
import ServiceTwo from '@/components/elements/service/ServiceTwo'
import Web3 from 'web3'

export default {
  name: 'Depost',
  components: {
    Icon,
    Layout,
    Counter,
    ServiceTwo,
  },
  data() {
    return {
      value: 0,
      iconOne: require('../assets/images/counter/icon-one.svg'),
      counterFiveData: [
        {
          number: 0,
          title: 'Current  Deposit',
          decimals: 2,
          icon: require('../assets/images/counter/icon-one.svg'),
        },
        {
          number: 0,
          title: 'Deposit APR ',
          suffix: '%',
          decimals: 2,
          icon: require('../assets/images/counter/icon-three.svg'),
        },
        {
          title: 'Claimable reward ',
          decimals: 2,
          icon: require('../assets/images/counter/icon-two.svg'),
        },
      ],
      web3: null,
      account: '',
      active: this.$route.params && this.$route.params.id ? parseInt(this.$route.params.id) : 1,
    }
  },
  watch: {
    "$route"(to, from) {
      if (to.params.id) {
        this.active = parseInt(to.params.id)
      }
    }
  },
  mounted() {
  },
  beforeUnmount() {
    // window.removeEventListener('scroll')
  },
  methods: {
    async selectMetamask() {
      await this.initWeb3()
      await this.getAccount()
    },
    async initWeb3() {
      if (window.ethereum) {
        this.web3 = new Web3(window.ethereum)
        try {
          await window.ethereum.enable()
        } catch (error) {
          console.log(error)
        }
      } else if (window.web3) {
        this.web3 = new Web3(window.web3.currentProvider)
      }
    },
    async getAccount() {
      if (this.web3) {
        const accounts = await this.web3.eth.getAccounts()
        if (Array.isArray(accounts) && accounts.length > 0) {
          this.account = accounts[0]
          this.$account.metamask = accounts[0]
        }
      } else {
        this.$message.info('请安装Metamask！')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.depost-area {
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.03);
  box-shadow: -2px 0px 20px 12px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(49px);
  padding-top: 53px
}

.depost-btn {
  width: 337.07px;
  height: 50px;
  background: #4E5973;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Outfit;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  border-radius: 20px;
  position: relative;
}

.depost-btn-active::before,
.depost-btn-active::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
}

.depost-btn-active::before {
  left: -20px;
  /* 设置径向渐变 */
  background: radial-gradient(
    circle at 0 0,
    transparent 20px,
    #1C2333 20px
  );
}
.depost-btn-active::after {
  right: -20px;
  /* 设置径向渐变 */
  background: radial-gradient(
    circle at 20px 0,
    transparent 20px,
    #1C2333 20px
  );
}

.depost-btn-active {
  color: #a1fe04;
  border-radius: 30px 30px 0px 0px;
  background: #1C2333;
}

.action-btn {
  width: 188px;
  height: 64px;
  border-radius: 18px;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
